import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { Campaign } from '~/api/models/campaign';
import { campaignsServiceApi, useLazyGetCampaignByIdQuery } from '~/api/campaigns/Campaign.api';

export const useCampaign = (initialCampaign?: Campaign) => {
    const [campaign, setCampaign] = useState<Campaign | undefined>(initialCampaign);
    const [getCampaign] = useLazyGetCampaignByIdQuery();
    const dispatch = useDispatch();
    const { campaignId } = useParams();

    const fetchCampaign = (cachedValue = true) => {
        getCampaign({ id: campaignId } as Campaign, cachedValue)
            .unwrap()
            .then((fetchedCampaign) => {
                setCampaign(fetchedCampaign);
                dispatch(campaignsServiceApi.util.invalidateTags(['Campaign']));
            })
            .catch((error) => {
                console.error('Failed to fetch campaign:', error);
            });
    };

    useEffect(() => {
        if (!campaign && campaignId) {
            fetchCampaign();
        }
    }, [campaign, campaignId]);

    return { campaign, fetchCampaign };
};
